import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { GetGameLeadersQuery } from "@/graphql/gql/graphql";
import { getGameLeaderStats } from "../api";

const useGameLeaders = (
  gameId: number,
  queryOptions: Partial<UseQueryOptions<GetGameLeadersQuery>> = {}
) => {
  const { data, isLoading, isError } = useQuery({
    ...queryOptions,
    queryKey: ["gameLeaders", gameId],
    queryFn: () => getGameLeaderStats(gameId),
  });

  return {
    data,
    isLoading,
    isError,
  };
};

export default useGameLeaders;
